import { FC, useEffect, useState } from "react";
import { Facture } from "../../lib/interfaces/facture.interface";
import { TableCell, TableRow } from "../ui/table";
import { formatDate } from "../../lib/helpers/date_helpers";
import { Button } from "../ui/button";
import { Download } from "lucide-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosClient from "../../lib/axiosClient";
import { ksFacturesQK } from "../../lib/query-keys";
import { getDownloadURL, ref } from "firebase/storage";
import { storage } from "../../lib/firebaseClient";

interface Props {
  facture: Facture;
}

const FactureRowItem: FC<Props> = ({ facture: fac }) => {
  const queryClient = useQueryClient();
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUrl = async () => {
      setLoading(true);
      const factureRef = ref(storage, fac.filePath);
      const urlFacture = fac.filePath ? await getDownloadURL(factureRef) : "";
      setUrl(urlFacture);
      setLoading(false);
    };
    getUrl();
  }, [storage, fac]);

  const { mutate: envoyerOuTelecharger, isPending } = useMutation({
    mutationFn: async () => {
      if (url) {
        window.open(url, "_blank");
      } else {
        await axiosClient.post("/factures/creer-pdf", {
          factureId: fac.id,
        });
        toast.success(
          "La facture vient de vous être envoyée par email. Vérifiez également vos courrier indésirables"
        );
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [ksFacturesQK] });
    },
    onError: (err: any) => {
      console.error(err.response?.data || err);
      toast.error(`Une erreur s'est produite`);
    },
  });

  return (
    <TableRow>
      <TableCell className="font-medium">{formatDate(fac.date)}</TableCell>
      <TableCell>{fac.description}</TableCell>
      <TableCell>{(fac.montant / 100).toFixed(2)}€</TableCell>
      <TableCell className="text-right">
        {/* <Tooltip label="Télécharger la facture"> */}
        <Button
          disabled={loading}
          onClick={() => envoyerOuTelecharger()}
          loading={isPending}
          icon={<Download className="w-4 h-4" />}
        />
        {/* </Tooltip> */}
      </TableCell>
    </TableRow>
  );
};

export default FactureRowItem;
